type TaskTimeEntry = {
  estimated_time_spent?: string | null;
  total_time?: number | null;
};

export function sumEstimatedTime(tasks: TaskTimeEntry[]): number | null {
  const values = tasks
    .map((t) => (t.estimated_time_spent ? Number(t.estimated_time_spent) : Number.NaN))
    .filter((n) => !Number.isNaN(n));
  if (values.length === 0) return null;
  return values.reduce((a, b) => a + b, 0);
}

export function sumTaskLoggedTime(tasks: TaskTimeEntry[]): number | null {
  const values = tasks.filter((t) => t.total_time != null).map((t) => t.total_time!);
  if (values.length === 0) return null;
  return values.reduce((a, b) => a + b, 0);
}
